import { BotFlow, StepSchema } from '@feedyou-ai/feedbot-schema'
import memoizeOne from 'memoize-one'

import { extractStepsFromDialogs } from '../../../../lib/dialogs'
import { runSsmlValidation } from '../../../ssml'
import { filterDialogs } from '../../../dialogsFiltering'
import { DialogHierarchyMap } from '../../../dialogRelation'
import { FullValidationResult } from '../../../../store/ssml/ssmlSlice'

export const validateSsmlInFlow = memoizeOne(async function validateSsmlInFlow(
  flow: BotFlow,
  hierarchyMap: DialogHierarchyMap
) {
  const entitiesToValidate = getEntitiesToValidate(flow, hierarchyMap)

  const result: FullValidationResult = {}

  for (const { entity, properties } of entitiesToValidate) {
    for (const property of properties) {
      if (!entity.id) {
        continue
      }

      result[entity.id] = {
        ...result[entity.id],
        // @ts-ignore
        [property]: await runSsmlValidation(entity[property], {
          propertyName: property,
          entityId: entity.id
        })
      }
    }
  }

  return result
})

function getEntitiesToValidate(
  flow: BotFlow,
  hierarchyMap: DialogHierarchyMap
): Array<{ entity: object & { id?: string }; properties: string[] }> {
  const result: Array<{ entity: object & { id?: string }; properties: string[] }> = []
  const filteredDialogs = filterDialogs(
    Object.values(flow?.dialogs || []),
    { excludeDisabled: true, excludeInaccessible: true },
    hierarchyMap
  )

  const steps = extractStepsFromDialogs(filteredDialogs)

  for (const step of steps) {
    result.push({ entity: step, properties: getSsmlPropertyNamesForStepType(step) })

    if (step.type === 'question' || step.type === 'prompt') {
      for (const answer of step.answers || []) {
        // @ts-ignore
        result.push({ entity: answer, properties: ['answer', 'title', 'subtitle', 'text'] })
      }
    }

    if (step.type === 'message') {
      for (const carouselItem of step.carousel || []) {
        // @ts-ignore
        result.push({ entity: carouselItem, properties: ['title', 'subtitle', 'text'] })
      }
    }
  }

  return result
}

export function getSsmlPropertyNamesForStepType(step: StepSchema): string[] {
  switch (step.type) {
    case 'email':
      return ['body']
    case 'prompt':
      return ['prompt', 'retryPrompt']
    case 'message':
      return ['message']
    case 'question':
      return ['question', 'retryPrompt']
    case 'attachment':
      return ['prompt']
    default:
      return []
  }
}
